// Routes owned by the Technical module. Merged into the app-wide `paths` object
// by src/app/paths.ts; see src/modules/README.md.
export const technicalPaths = {
    reportWAF: '/technical/report',
    // Technical
    technical: '/technical',
    // Threshold (Healthcheck Monitoring)
    threshold: '/technical/threshold',
    thresholdCreate: '/technical/threshold/new',
    thresholdDetail: '/technical/threshold/:id',
    thresholdEdit: '/technical/threshold/:id/edit',
    // Watchpoint
    watchpoint: '/technical/watchpoint',
    watchpointList: '/technical/watchpoint/watchpoints',
    watchpointCreate: '/technical/watchpoint/watchpoints/new',
    watchpointDetail: '/technical/watchpoint/watchpoints/:id',
    watchpointEdit: '/technical/watchpoint/watchpoints/:id/edit',
    watchpointAlarms: '/technical/watchpoint/alarms',
    watchpointEvents: '/technical/watchpoint/events',
    watchpointChannels: '/technical/watchpoint/channels',
    watchpointChannelDetail: '/technical/watchpoint/channels/:id',
    watchpointPlaybooks: '/technical/watchpoint/playbooks',
    watchpointPlaybookCreate: '/technical/watchpoint/playbooks/new',
    watchpointPlaybookDetail: '/technical/watchpoint/playbooks/:id',
    watchpointPlaybookEdit: '/technical/watchpoint/playbooks/:id/edit',
} as const
